import { motion } from "framer-motion";
import { FaFileAlt, FaMapMarkedAlt, FaDraftingCompass, FaShieldAlt } from "react-icons/fa";

const TrustSection = () => {
  const items = [
    { icon: <FaDraftingCompass />, text: "Planos técnicos profesionales" },
    { icon: <FaShieldAlt />, text: "Experiencia en saneamiento físico legal" },
    { icon: <FaMapMarkedAlt />, text: "Análisis predial y catastral" },
    { icon: <FaFileAlt />, text: "Asesoría personalizada y segura" },
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">

        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-3xl font-bold text-center text-[#1C1C1C]"
        >
          Más que planos, soluciones completas
        </motion.h2>

        <div className="mt-12 grid md:grid-cols-4 gap-8">
          {items.map((item, index) => (
            <motion.div
              key={index}
              whileHover={{ y: -5 }}
              className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 text-center"
            >
              <div className="text-[#F26B1D] text-3xl mb-4 flex justify-center">
                {item.icon}
              </div>
              <p className="text-gray-700 font-medium">{item.text}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrustSection;